import { render, staticRenderFns } from "./relate-name-dialog.vue?vue&type=template&id=01e4495c&scoped=true"
import script from "./relate-name-dialog.vue?vue&type=script&lang=ts"
export * from "./relate-name-dialog.vue?vue&type=script&lang=ts"
import style0 from "./relate-name-dialog.vue?vue&type=style&index=0&id=01e4495c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e4495c",
  null
  
)

export default component.exports